/* eslint-disable no-else-return */
// import React from 'react';
import _ from 'lodash';
import React from 'react';
import moment from 'moment';

// import { useSelector } from 'react-redux';

import { ATTRIBUTE_TYPE } from '../../../HelperMethods/FormUtils';
// import { ATTRIBUTE_TYPE as attributeTypeEnum } from '../../../HelperMethods/enums';
import { PICKLIST_OPTIONS, assetOptions } from './constants';
import GlobalAttributeComponent from './GlobalAttributeComponent';
// eslint-disable-next-line import/no-cycle
import GeofenceComponent from './GeoFenceComponent';
import AvailibiltyCompoent from './AvailibilityComponent';
import { convertavailabilityTocertainTimeZone } from '../../../HelperMethods/AssetFormUtilities';
// eslint-disable-next-line import/no-cycle
import { mapErrorToField, geofencedestructor, geofenceMapper } from './lib/Mapper';
import PreferredLocationComponent from './PreferredLocationComponent';
import { mapErrorToPreferredLocationFormField } from '../helper';
import StopComponent from './StopComponent';
// const Useistest = () => {
//   const GlobalAttributes = useSelector((state) => state.globalAttributeReducer.attributes).filter(
//     (item) => item.entityType === 'asset'
//   );
//   return GlobalAttributes;
// };

const SCHEMA_CONSTANTS = {
  g_id: {
    displayName: 'ID',
    path: 'id',
    type: ATTRIBUTE_TYPE.STRING,
    hide: true,
    attributeName: 'id',
    finalPath: 'id',
  },

  g_assetName: {
    displayName: 'Asset Name',
    type: ATTRIBUTE_TYPE.STRING,
    path: 'name',
    isMandatory: true,
    attributeName: 'assetName',
    finalPath: 'name',
  },
  g_description: {
    displayName: 'Description',
    type: ATTRIBUTE_TYPE.STRING,
    path: 'description',
    attributeName: 'description',
    width: 0.3333333333,
    finalPath: 'description',
  },
  g_assetType: {
    displayName: 'Asset Type',
    type: ATTRIBUTE_TYPE.PICKLIST,
    isMandatory: (formValues) => {
      const formvalues = _.get(formValues, 'formValues');
      // update asset case
      if (_.isEmpty(_.get(formvalues, 'g_id', ''))) {
        return true;
      }
      return false;
    },
    disabled: (formValues) => {
      const formvalues = _.get(formValues, 'formValues');

      // update asset case
      if (_.isEmpty(_.get(formvalues, 'g_id', ''))) {
        return false;
      }
      return true;
    },

    path: 'type',
    attributeName: 'assetType',
    // disabled: true,
    finalPath: 'type',
    options: assetOptions(),
    onChange: 'onAssettypeChange',
    width: 0.3333333333,
  },

  g_field: {
    displayName: 'Field',
    type: ATTRIBUTE_TYPE.PICKLIST,
    finalPath: 'fieldId',
    isMandatory: true,
    optionsVariableName: PICKLIST_OPTIONS.fieldOptions,
    onChange: 'onFieldChange',
    path: 'fieldId',
    attributeName: 'field',
    width: 0.3333333333,
  },
  g_areas: {
    displayName: 'Areas',
    type: ATTRIBUTE_TYPE.STRING,
    attributeName: 'areas',
    finalPath: 'areas',
    hide: ({ formValues }) => {
      if (_.isEmpty(formValues.g_areas)) return true;
      return false;
    },
    width: 0.5,
    path: (asset) => {
      let areaNameList = '';
      if (!_.isEmpty(asset.areas)) {
        asset.areas.forEach((areaObj) => {
          if (areaNameList) areaNameList = `${areaNameList}, ${areaObj.areaName}`;
          else {
            areaNameList = `${areaObj.areaName}`;
          }
        });
      }

      return areaNameList;
    },

    disabled: true,
  },
  g_stop: {
    displayName: 'Stop',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(StopComponent, { ...props }),

    finalPath: 'stopId',
    isMandatory: (formValues) => {
      /* eslint-disable camelcase */

      if (formValues?.g_assetType === 'stop') return false;
      return true;
    },
    hide: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') {
        return true;
      }
      return false;
    },
    fullRow: true,
    path: 'stopId',
    attributeName: 'stop',
    disabled: ({ formValues }) => {
      /* eslint-disable camelcase */
      if (formValues.g_assetType === 'stop') return true;
      return false;
    },
    width: 0.3333333333,
  },
  // g_xid: {
  //   displayName: 'XID',
  //   type: ATTRIBUTE_TYPE.STRING,
  //   path: 'xid',
  //   attributeName: 'xid',
  //   disabled: true,
  // },
  geo_latitude: {
    displayName: 'Latitude',
    type: ATTRIBUTE_TYPE.DECIMAL,
    path: 'latitude',
    finalPath: 'latitude',

    // isMandatory: (formValues) => {
    //   if (formValues.g_assetType === 'stop') return true;
    //   return false;
    // },
    attributeName: 'latitude',
    hide: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') {
        return false;
      }
      return true;
    },
    setValue: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') return { latitude: formValues.geo_latitude };
      return {};
    },
    width: 0.33333,
  },
  geo_longitude: {
    displayName: 'Longitude',
    type: ATTRIBUTE_TYPE.DECIMAL,
    path: 'longitude',
    finalPath: 'longitude',

    // isMandatory: (formValues) => {
    //   if (formValues.g_assetType === 'stop') return true;
    //   return false;
    // },
    attributeName: 'longitude',
    hide: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') {
        return false;
      }
      return true;
    },
    setValue: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') return { latitude: formValues.geo_latitude };
      return {};
    },
    onChange: 'onGeoLoacationChange',

    width: 0.33333,
  },

  availability_availability: {
    displayName: 'Availability Details',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(AvailibiltyCompoent, { ...props }),
    hide: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') {
        return false;
      }
      return true;
    },
    finalPath: 'availability',
    isMandatory: (formValues) => {
      if (formValues.g_assetType === 'stop') return true;
      return false;
    },
    path: (asset) => {
      const availabilityObj = (asset.availability || []).map((item) => {
        return {
          availabilityStartTime: moment(item.startTime).format('HH:mm'),
          availabilityStartDate: moment(item.startDate).format('YYYY-MM-DD'),
          availabilityEndTime: moment(item.endTime).format('HH:mm'),
          availabilityEndDate: moment(item.endDate).format('YYYY-MM-DD'),
        };
      });
      availabilityObj.push({
        availabilityStartTime: '',
        availabilityStartDate: '',
        availabilityEndTime: '',
        availabilityEndDate: '',
      });
      return availabilityObj;
    },
    setValue: ({ formValues }) => {
      const clonedParts = _.cloneDeep(formValues.availability_availability);
      const availability = clonedParts.filter(
        (availabilityobj) =>
          availabilityobj.availabilityStartTime &&
          availabilityobj.availabilityStartDate &&
          availabilityobj.availabilityEndTime &&
          availabilityobj.availabilityEndDate
      );
      const returnValue = convertavailabilityTocertainTimeZone(availability, 'America/Chicago');
      return { availability: returnValue };
    },

    width: 1,
    validations: ({ formValues }) => mapErrorToField({ formValues }),
    // validations: [{ validateFunc: ({ formValues }) => mapErrorToField({ formValues }) }],
  },

  geofence_geofenceDetails: {
    displayName: 'Geofence Details',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(GeofenceComponent, { ...props }),
    LatitudeDisplayName: 'Latitude',
    LongitudeDisplayName: 'Longitude',
    RadiusDisplayName: 'Radius',
    finalPath: 'geofence',
    width: 1,
    isMandatory: (formValues) => {
      if (formValues.g_assetType === 'stop') return true;
      return false;
    },
    polygonArea: 'polygonArea',
    path: (asset) => {
      let polygonAreaObj = _.cloneDeep(asset.geofence) || {};
      if (Object.keys(polygonAreaObj).length === 0) {
        polygonAreaObj = { type: '', radius: '50', polygon: [{ latitude: '', longitude: '' }] };
      } else {
        return geofencedestructor(polygonAreaObj);
      }
      return polygonAreaObj;
    },
    setValue: ({ formValues }) => {
      const clonedParts = _.cloneDeep(formValues.geofence_geofenceDetails);
      const { type } = clonedParts;

      if (formValues.g_assetType === 'stop' && !_.isEmpty(type)) return { geofence: geofenceMapper(clonedParts) };

      return {};
    },
    circleArea: 'circleArea',
    hide: ({ formValues }) => {
      if (formValues.g_assetType === 'stop') {
        return false;
      }
      return true;
    },
    validations: [
      {
        validateFunc: ({ formValues }) => {
          const { type } = formValues.geofence_geofenceDetails;
          if (formValues.g_assetType !== 'stop' && _.isEmpty(type)) return true;
          const radialState = formValues.geofence_geofenceDetails.type === 'radial';
          const geofenceDetails = formValues.geofence_geofenceDetails;
          const latitude = formValues.geo_latitude;
          const longitude = formValues.geo_longitude;
          if (radialState) {
            if (
              _.isEmpty(geofenceDetails.radius.toString()) ||
              _.isEmpty(latitude.toString()) ||
              _.isEmpty(longitude.toString())
            ) {
              return false;
            }
            return true;
          }
          return true;
        },
        message: 'Some fields are missing',
      },
      {
        validateFunc: ({ formValues }) => {
          const { type } = formValues.geofence_geofenceDetails;
          if (formValues.g_assetType !== 'stop' && _.isEmpty(type)) return true;
          const radialState = formValues.geofence_geofenceDetails.type === 'radial';
          const { radius } = formValues.geofence_geofenceDetails;

          if (radialState && radius.toString() === '0') return false;
          return true;
        },
        message: 'Radius cannot be zero',
      },
      {
        validateFunc: ({ formValues }) => {
          const radialState = formValues.geofence_geofenceDetails.type === 'radial';
          const polugonState = formValues.geofence_geofenceDetails.type === 'polygon';
          const { type } = formValues.geofence_geofenceDetails;
          if (formValues.g_assetType !== 'stop' && _.isEmpty(type)) return true;
          if (!radialState && polugonState) {
            const geofenceDetails = formValues.geofence_geofenceDetails;

            const tempcoordinates = _.cloneDeep(geofenceDetails.polygon);
            const filteredtempCoordinates = tempcoordinates.filter(
              (coordinate) => coordinate.latitude && coordinate.longitude
            );
            if (filteredtempCoordinates.length < 3) return false;
            else {
              const returnedTest = filteredtempCoordinates.map((coordinate, index) => {
                if (index < 3 && (_.isEmpty(coordinate.latitude) || _.isEmpty(coordinate.longitude))) {
                  return false;
                }
                return true;
              });
              const finalreturn = returnedTest.some((testValue) => testValue === false);

              return !finalreturn;
            }
          } else return true;
        },
        message: 'Minimum three coordinates required',
      },
    ],
  },
  att_attachements: {
    displayName: 'Attachments',
    type: ATTRIBUTE_TYPE.PICKLIST,
    finalPath: 'attachments',
    path: (asset) => {
      const { attachments } = asset;
      const returnArray = [];
      if (!_.isEmpty(attachments)) {
        attachments.forEach((attachment) => {
          if (attachment.key) returnArray.push(attachment.key);
        });
      }
      return returnArray;
    },
    setValue: ({ formValues }) => {
      const attachments = formValues.att_attachements || [];

      return { attachments };
    },
    optionsVariableName: PICKLIST_OPTIONS.attachmentOptions,
    multiple: true,
    attributeName: 'attachments',
  },
  wat_staticList: {
    displayName: 'Watchers',
    type: ATTRIBUTE_TYPE.PICKLIST,
    path: 'watchers',
    finalPath: 'watchers',
    attributeName: 'watchers',
    optionsVariableName: PICKLIST_OPTIONS.userListPicklist,
    onchange: 'onAssettypeChange',
    multiple: true,
  },

  global_attributes: {
    displayName: 'Custom Global Attribute',
    type: ATTRIBUTE_TYPE.CUSTOM,
    finalPath: 'customAttributes',
    component: (props) => React.createElement(GlobalAttributeComponent, { ...props }),
    attributeName: 'customAttribute',
    // path: 'customAttributes',
    path: (asset) => {
      const globalAttribute = _.cloneDeep(asset.customAttributes) || {};
      return globalAttribute;
    },
    setValue: ({ formValues }) => {
      const globalAttributeList = formValues.global_attributes;
      return { customAttributes: globalAttributeList };
    },
    entityType: 'g_assetType',
    entityDisplayName: 'Object Type',
    attributeTypeDisplayName: 'Attribute Type',
    displayAttributeName: 'Display Name',
    width: 1,
  },
  preferred_location: {
    displayName: 'Preffered Locations',
    type: ATTRIBUTE_TYPE.CUSTOM,
    finalPath: 'preferredLocations',
    isMandatory: true,
    optionsVariableName: PICKLIST_OPTIONS.fieldOptions,
    onChange: 'onFieldChange',
    component: (props) => React.createElement(PreferredLocationComponent, { ...props }),
    // isMandatory: true,
    // fullRow: true,
    path: (task) => {
      const prefLocation = _.cloneDeep(task.preferredLocations) || {};
      const prefLocationArr = [];
      Object.keys(prefLocation).forEach((key) => {
        prefLocationArr.push({ locationType: key, location: prefLocation[key] });
      });
      prefLocationArr.push({ locationType: '', location: '' });
      return prefLocationArr;
    },
    setValue: ({ formValues }) => {
      const preferredLocationVal = _.cloneDeep(formValues.preferred_location) || [];
      const preferredLocations = {};
      const filteredPreferredLocation = preferredLocationVal.filter((loc) => loc.locationType && loc.location);
      filteredPreferredLocation.forEach(({ locationType, location }) => {
        preferredLocations[locationType] = location;
      });
      return { preferredLocations };
    },
    attributeName: 'preferredLocations',
    validations: mapErrorToPreferredLocationFormField,
  },
};

export default SCHEMA_CONSTANTS;
